import { Link } from 'gatsby';
import propType from 'prop-types';
import React from 'react';

export default function IconText({ icon, to, children }) {
  return (
    <Link to={to} className="internal-link icon-text">
      {icon} {children}
    </Link>
  );
}

IconText.propTypes = {
  icon: propType.node.isRequired,
  to: propType.string.isRequired,
  children: propType.node.isRequired
};
